/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBrightDataISPProxyRequest
 */
export interface CreateBrightDataISPProxyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBrightDataISPProxyRequest
     */
    proxyName: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBrightDataISPProxyRequest
     */
    ipCount: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBrightDataISPProxyRequest
     */
    countryCode: string;
}

/**
 * Check if a given object implements the CreateBrightDataISPProxyRequest interface.
 */
export function instanceOfCreateBrightDataISPProxyRequest(value: object): value is CreateBrightDataISPProxyRequest {
    if (!('proxyName' in value) || value['proxyName'] === undefined) return false;
    if (!('ipCount' in value) || value['ipCount'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function CreateBrightDataISPProxyRequestFromJSON(json: any): CreateBrightDataISPProxyRequest {
    return CreateBrightDataISPProxyRequestFromJSONTyped(json, false);
}

export function CreateBrightDataISPProxyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBrightDataISPProxyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'proxyName': json['proxy_name'],
        'ipCount': json['ip_count'],
        'countryCode': json['country_code'],
    };
}

export function CreateBrightDataISPProxyRequestToJSON(json: any): CreateBrightDataISPProxyRequest {
    return CreateBrightDataISPProxyRequestToJSONTyped(json, false);
}

export function CreateBrightDataISPProxyRequestToJSONTyped(value?: CreateBrightDataISPProxyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proxy_name': value['proxyName'],
        'ip_count': value['ipCount'],
        'country_code': value['countryCode'],
    };
}

